import {
    DesvincularTelaGrupoController,
    ListarTelasDesvinculadasPorGrupoController,
    ListarTelasPorGrupoController,
    VincularTelaGrupoController,
} from "../../../../../Controllers/Geral/Grupos/GrupoTelasController";
import VinculadorSimples from "../../../../../Components/Table/Vinculador";
import { ACESSOS } from "../../../../../Routes/Acessos";

interface TelasProps {
    idGrupo: number;
}

export default function Telas(props: TelasProps) {
    const accessos = ACESSOS;

    type Tela = {
        DS_PATH: string;
        DS_LINK?: (param: number) => string;
    };

    type Modulo = {
        TELAS: Record<string, Tela>;
        DS_BASE_URL: string;
    };

    const extractPaths = (acessos: Record<string, any>): string[] => {
        const paths: string[] = [];
        const extractFromModulo = (modulo: Modulo): void => {
            if (modulo.DS_BASE_URL && modulo.DS_BASE_URL.trim() !== "") {
                paths.push(modulo.DS_BASE_URL.toLowerCase());
            }
        };
        Object.values(acessos).forEach((modulo) => {
            extractFromModulo(modulo);
        });
        return paths.filter(
            (path) => path !== null && path !== undefined && path !== ""
        );
    };

    const extractIds = (acessos: any): number[] => {
        const idsSet: Set<number> = new Set(); // set para não permitir ids duplicados

        const extractFromObject = (obj: any) => {
            for (const key in obj) {
                if (obj.hasOwnProperty(key)) {
                    const value = obj[key];
                    if (typeof value === "object") {
                        extractFromObject(value);
                    } else if (key === "ID_TELA") {
                        idsSet.add(value);
                    }
                }
            }
        };

        extractFromObject(acessos);

        return Array.from(idsSet);
    };

    const telasIds = extractIds(ACESSOS);
    const telasPaths = extractPaths(accessos);

    async function verificaTelasVinculadasExistentes(idGrupo: number) {
        const telas = await ListarTelasPorGrupoController(idGrupo);
        let telasVerificadas: any[] = [];
        telas.forEach((tela) => {
            if (telasIds.includes(tela.ID_TELA)) {
                telasVerificadas.push(tela);
            } else if (telasPaths.includes(tela.DS_URL_TELA)) {
                telasVerificadas.push(tela);
            }
        });

        return telasVerificadas;
    }

    async function verificaTelasDesvinculadasExistentes(idGrupo: number) {
        const telas = await ListarTelasDesvinculadasPorGrupoController(idGrupo);
        let telasVerificadas: any[] = [];
        telas.forEach((tela) => {
            if (telasIds.includes(tela.ID_TELA)) {
                telasVerificadas.push(tela);
            } else if (telasPaths.includes(tela.DS_URL_TELA)) {
                telasVerificadas.push(tela);
            }
        });
        return telasVerificadas;
    }

    return (
        <VinculadorSimples
            id={props.idGrupo}
            title="Telas por grupo"
            listarVinculados={(id: number) =>
                verificaTelasVinculadasExistentes(id)
            }
            listarNaoVinculados={(id: number) =>
                verificaTelasDesvinculadasExistentes(id)
            }
            multiplo={{
                desvincular: (ts) =>
                    DesvincularTelaGrupoController(
                        ts.map((t) => t.ID_GRUPO_TELA || 0)
                    ),
                vincular: (idGrupo, telas) =>
                    VincularTelaGrupoController(
                        telas.map((tela) => ({
                            ID_TELA: tela.ID_TELA,
                            ID_GRUPO: idGrupo,
                        }))
                    ),
            }}
            tabelaVinculados={{
                text: "Telas Vinculadas",
                dataField: "DS_NOME_TELA",
                key: "ID_GRUPO_TELA",
            }}
            tabelaDesvinculados={{
                text: "Telas desvinculadas",
                dataField: "DS_NOME_TELA",
                key: "ID_TELA",
            }}
        />
    );
}
